const e = "‎", r = 59, n = 23, c = 31, a = 12, o = 9999, A = "HH:mm", _ = 60, E = (t) => t.replaceAll(e, ""), M = (t, s) => ((t == null ? void 0 : t.match(
  new RegExp(`[\\d\\${s}${e}]`, "g")
)) ?? []).join(""), m = (t, s) => ((t == null ? void 0 : t.match(
  new RegExp(`[^\\d\\${s}${e}]`, "g")
)) ?? []).join(""), T = (t) => {
  switch (t) {
    case "D":
      return "day";
    case "M":
      return "month";
    case "Y":
      return "year";
    case "H":
      return "hour";
    case "m":
      return "minute";
  }
  return null;
};
export {
  c as D,
  e as F,
  n as H,
  a as M,
  A as T,
  o as Y,
  m as a,
  T as b,
  _ as c,
  r as d,
  M as g,
  E as r
};
//# sourceMappingURL=date-time.BhxcicEx.js.map
